import { useEffect, useState } from "react";

export const KarmaPoolNoteManager = (local, setLocal, parentRefresh, getURLBasePath) => {

    const [latestHash, setLatestHash] = useState(null);

    const [activeFilter, setActiveFilter] = useState({
        topFilter: {
            musicNotesOnly: false,
            textNotesOnly: false,
            newsletterOnly: false,
            newsletterId: 1
        },
        followingOnly: false,
        locked: true
    });

    useEffect(() => {
        if (activeFilter.locked) {
            return;
        }

        fetchLatestNotes();
    }, [activeFilter]);

    useEffect(() => {
        clearLatestNotes();
    }, []);

    function clearLatestNotes() {
        setLocal(prevValue => {
            return { ...prevValue, latestNotes: null };
        });
    }

    function setTopFilter(filter) {
        setActiveFilter(prevValue => {
            return { ...prevValue, topFilter: filter, locked: false };
        });

        if ((filter.musicNotesOnly && !activeFilter.topFilter.textNotesOnly) ||
            (filter.textNotesOnly && !activeFilter.topFilter.musicNotesOnly)) {

        }
        else {
            setLocal(prevValue => {
                return { ...prevValue, latestNotes: null };
            });
        }
    }

    function setFollowingOnly(followingOnly) {
        setActiveFilter(prevValue => {
            return { ...prevValue, followingOnly: followingOnly, locked: false };
        });

        setLocal(prevValue => {
            return { ...prevValue, latestNotes: null };
        });
    }

    function getLatestNotes() {
        return local.latestNotes;
    }

    function getNumberOfMusicNotes() {
        if (local.noteSummaries != null && local.noteSummaries !== undefined && local.noteSummaries.length > 0) {
            return local.noteSummaries.filter(note => note.noteType != null &&
                (note.noteType === "MUSIC_NOTE")).length;
        }
        return 0;
    }

    function getNumberOfTextNotes() {
        if (local.noteSummaries != null && local.noteSummaries !== undefined && local.noteSummaries.length > 0) {
            return local.noteSummaries.filter(note => note.noteType != null &&
                (note.noteType !== "MUSIC_NOTE")).length;
        }
        return 0;
    }

    function getMusicNotes() {
        if (local.latestNotes != null && local.latestNotes !== undefined && local.latestNotes.length > 0) {
            return local.latestNotes.filter(note => note.url != null &&
                ((note.url.includes("youtube") || note.url.includes("youtu.be")) || note.url.includes("spotify.com")));
        }
        return [];
    }

    function getTextNotes() {
        if (local.latestNotes != null && local.latestNotes !== undefined && local.latestNotes.length > 0) {
            return local.latestNotes.filter(note => note.url == null ||
                (!note.url.includes("youtube.com") && !note.url.includes("spotify.com")));
        }
        return [];
    }

    function getNumberOfNotes() {
        if (local.noteSummaries != null && local.noteSummaries.length > 0) {
            return local.noteSummaries.length;
        }
        return 0;
    }

    function postNote(note) {
        fetch(getURLBasePath() + 'note', {
            method: 'POST',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(note)
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                fetchLatestNotes();
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    const [latestNotesForRaceCheck, setLatestNotesForRaceCheck] = useState(null);
    const [latestNotesHashForRaceCheck, setLatestNotesHashForRaceCheck] = useState(null);

    useEffect(() => {
        if (latestNotesForRaceCheck != null && latestNotesForRaceCheck !== undefined) {
            if (latestNotesHashForRaceCheck === latestHash) {
                setLocal(prevValue => {
                    return { ...prevValue, latestNotes: latestNotesForRaceCheck };
                });

                setIsLoadingNotes(false);
            }
            else {
                console.log("skipping due to repeat hash " + latestNotesHashForRaceCheck + " - " + latestHash);
            }
        }
    }, [latestNotesHashForRaceCheck]);

    const [latestSummaryNotesForRaceCheck, setLatestSummaryNotesForRaceCheck] = useState(null);
    const [latestSummaryNotesHashForRaceCheck, setLatestSummaryNotesHashForRaceCheck] = useState(null);

    const [notesLoading, setIsLoadingNotes] = useState(false);

    useEffect(() => {
        if (latestSummaryNotesForRaceCheck != null && latestSummaryNotesForRaceCheck !== undefined) {
            if (latestSummaryNotesHashForRaceCheck === latestHash) {
                setLocal(prevValue => {
                    return { ...prevValue, noteSummaries: latestSummaryNotesForRaceCheck };
                });
            }
            else {
                console.log("skipping due to repeat hash " + latestSummaryNotesHashForRaceCheck + " - " + latestHash);
            }
        }
    }, [latestSummaryNotesHashForRaceCheck]);

    function isLoadingNotes() {
        return notesLoading;
    }

    function fetchLatestNotes() {

        let randomRequestHash = Math.random().toString(36).substring(7);
        setLatestHash(randomRequestHash);
        setIsLoadingNotes(true);
        console.log("request hash: " + randomRequestHash);

        let pathNotes = getURLBasePath() + 'note?pageSize=30&page=1';

        let pathNoteSummaries = getURLBasePath() + 'noteSummaries?';

        if (activeFilter.topFilter.musicNotesOnly) {
            pathNotes += '&isMusicOnly=true';
        }

        if (activeFilter.topFilter.textNotesOnly) {
            pathNotes += '&isTextOnly=true';
        }

        if (activeFilter.topFilter.newsletterOnly) {
            pathNotes += '&isNewsletterOnly=true';
            pathNotes += '&newsletterId=' + activeFilter.topFilter.newsletterId;
        }

        if (activeFilter.followingOnly) {
            pathNotes += '&isFollowingOnly=true';
            pathNoteSummaries += '&isFollowingOnly=true';
        }

        fetch(pathNotes, {
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log("data for notes: " + randomRequestHash);
                setLatestNotesForRaceCheck(data);
                setLatestNotesHashForRaceCheck(randomRequestHash);
            })
            .catch((err) => {
                console.log(err.message);
            });

        fetch(pathNoteSummaries, {
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                setLatestSummaryNotesForRaceCheck(data);
                setLatestSummaryNotesHashForRaceCheck(randomRequestHash);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function fetchProfileNotes(userId) {

        setLocal(prevValue => {
            return { ...prevValue, profileNotes: null };
        });

        fetch(getURLBasePath() + 'note' + '?userId=' + userId + '&isCurrentlyFeeling=true', {
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json',
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                setLocal(prevValue => {
                    return { ...prevValue, profileNotes: data };
                });
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function deleteNote(noteId) {
        fetch(getURLBasePath() + 'note/' + noteId, {
            method: 'DELETE',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => {
                fetchLatestNotes();
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function loveNote(noteId) {
        fetch(getURLBasePath() + 'note/' + noteId + '/love', {
            method: 'POST',
            body: JSON.stringify({ loved: true}),
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => {
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function unloveNote(noteId) {
        fetch(getURLBasePath() + 'note/' + noteId + '/love', {
            method: 'POST',
            body: JSON.stringify({ loved: false}),
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => {
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    return {
        postNote, fetchLatestNotes, fetchProfileNotes, getNumberOfMusicNotes, getNumberOfTextNotes, getNumberOfNotes, getTextNotes, getMusicNotes, getLatestNotes, setTopFilter, setFollowingOnly,
        isLoadingNotes, clearLatestNotes, deleteNote, loveNote, unloveNote
    };
}